module.exports = __webpack_public_path__ + "static/media/silicon.a5f3c0e7.png";